/* Shared video-tile behavior for VideoReviews + BigFeatureBlocks.
   Ports useLazyVideo + the play/pause/mute logic. Tiles autoplay muted+loop
   when scrolled into view; click toggles play/pause; sound button toggles mute. */
(function () {
  "use strict";
  function init() {
    var tiles = Array.prototype.slice.call(document.querySelectorAll("[data-video-tile]"));
    if (!tiles.length) return;

    tiles.forEach(function (tile) {
      var video = tile.querySelector("[data-tile-video]");
      var playIcon = tile.querySelector("[data-tile-playicon]");
      var pauseIcon = tile.querySelector("[data-tile-pauseicon]");
      var overlay = tile.querySelector("[data-tile-overlay]");
      var center = tile.querySelector("[data-tile-center]");
      var soundOn = tile.querySelector("[data-tile-soundon]");
      var soundOff = tile.querySelector("[data-tile-soundoff]");
      var loaded = false;

      function reflect(playing) {
        if (center) center.classList.toggle("opacity-0", playing);
        if (center) center.classList.toggle("group-hover:opacity-100", playing);
        if (center) center.classList.toggle("opacity-100", !playing);
        if (overlay) overlay.classList.toggle("opacity-50", playing);
        if (overlay) overlay.classList.toggle("group-hover:opacity-100", playing);
        if (overlay) overlay.classList.toggle("opacity-100", !playing);
        if (playIcon) playIcon.hidden = playing;
        if (pauseIcon) pauseIcon.hidden = !playing;
      }

      if (!video) { reflect(false); return; }

      function ensureLoaded() {
        if (loaded) return;
        var src = video.getAttribute("data-src");
        if (src) { video.src = src; loaded = true; }
      }

      tile.addEventListener("click", function () {
        if (video.paused) { ensureLoaded(); video.play().catch(function () {}); reflect(true); }
        else { video.pause(); reflect(false); }
      });
      tile.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") { e.preventDefault(); tile.click(); }
      });

      if (soundOn || soundOff) {
        var btn = tile.querySelector("[data-tile-sound]");
        if (btn) btn.addEventListener("click", function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          if (soundOn) soundOn.hidden = video.muted;
          if (soundOff) soundOff.hidden = !video.muted;
        });
      }

      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { ensureLoaded(); video.play().then(function () { reflect(true); }).catch(function () {}); }
            else { video.pause(); }
          });
        }, { threshold: 0.35 });
        io.observe(tile);
      } else { ensureLoaded(); }

      reflect(true);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
